import { IPanelTableData } from './panel-table.models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'panel-table',
  template: require('./panel-table.component.html'),
  styles: [require('./panel-table.component.scss')],
})
export class PanelTableComponent {
  @Input() tableData: IPanelTableData | any;
}
